module.exports = "/_next/static/images/intelligence-benchmark-56f36074c5e4826ee59707cba7627149.png";